.my-balance__page-header-bar__action-items {
  display: flex;
  flex-direction: row;
}
